@if (!isLoading) {
    <router-outlet></router-outlet>
}
